<script>
import GenericCrud from "@forms/GenericCrud.vue";
import api from "@services/api";

export default {
  extends: GenericCrud,
  props: {
    table: {
      type: String,
      default: "ContratoDespesa"
    }
  },
  data: () => ({
    contratoDespesaTipoList: {},
    contratoList: {}
  }),
  created() {
    this.getContratoList();
    this.getContratoDespesaTipoList();
  },
  methods: {
    getContratoDespesaTipoList() {
      api
        .get(`crud/ContratoDespesaTipo`, {
          params: {
            sortBy: "descricao",
            sortOrder: "ASC"
          }
        })
        .then(
          response => (this.contratoDespesaTipoList = response.data["data"])
        );
    },
    getContratoList() {
      api
        .get(`crud/Contrato`, {
          params: {
            sortBy: "descricao",
            sortOrder: "ASC"
          }
        })
        .then(response => (this.contratoList = response.data["data"]));
    }
  }
};
</script>

<template>
  <div>
    <b-form @submit.prevent="save">
      <b-form-group id="input-group-1" label="Contrato" label-for="contratoId">
        <b-form-select
          id="contratoId"
          v-model="item.contratoId"
          :disabled="!this.editForm"
          required
        >
          <b-form-select-option disabled :value="undefined"
            >Selecione um item da lista</b-form-select-option
          >
          <b-form-select-option
            v-for="option in contratoList"
            :key="option.id"
            :value="option.id"
          >
            {{ option.descricao }}
          </b-form-select-option>
        </b-form-select>
      </b-form-group>

      <b-form-group
        id="input-group-2"
        label="Tipo de despesa do contrato"
        label-for="contratoDespesaTipoId"
      >
        <b-form-select
          id="contratoDespesaTipoId"
          v-model="item.contratoDespesaTipoId"
          :disabled="!this.editForm"
          required
        >
          <b-form-select-option disabled :value="undefined"
            >Selecione um item da lista</b-form-select-option
          >
          <b-form-select-option
            v-for="option in contratoDespesaTipoList"
            :key="option.id"
            :value="option.id"
          >
            {{ option.descricao }}
          </b-form-select-option>
        </b-form-select>
      </b-form-group>

      <b-form-group id="input-group-1" label="Descrição" label-for="descricao">
        <b-form-input
          id="descricao"
          v-model="item.descricao"
          :disabled="!this.editForm"
          type="text"
          required
        ></b-form-input>
      </b-form-group>

      <div class="row">
        <b-form-group
          id="input-group-1"
          label="Data"
          label-for="data"
          class="col-md-6"
        >
          <b-form-datepicker
            id="data"
            v-model="item.data"
            :disabled="!this.editForm"
            required
            placeholder="Selecione uma data"
            :hide-header="true"
          ></b-form-datepicker>
        </b-form-group>

        <b-form-group
          id="input-group-1"
          label="Valor"
          label-for="valor"
          class="col-md-6"
        >
          <b-form-input
            id="valor"
            v-model="item.valor"
            :disabled="!this.editForm"
            type="number"
            step="0.01"
            min="0.00"
            max="999999.00"
            required
          ></b-form-input>
        </b-form-group>
      </div>

      <b-form-group id="button-group" class="mt-4" v-show="this.editForm">
        <b-button variant="light" class="btn" v-on:click="back()"
          >Cancelar</b-button
        >
        <b-button type="submit" variant="primary" class="btn ml-2"
          >Salvar</b-button
        >
      </b-form-group>

      <b-form-group id="button-group" class="mt-4" v-show="!this.editForm">
        <b-button variant="light" class="btn" v-on:click="back()"
          >Voltar</b-button
        >
        <b-button variant="primary" class="btn ml-2" v-on:click="edit()"
          >Editar</b-button
        >
        <b-button variant="danger" class="btn ml-2" v-on:click="remove()"
          >Remover</b-button
        >
      </b-form-group>
    </b-form>
    <b-modal
      v-model="showModalDelete"
      title="Deseja realmente excluir?"
      centered
      hide-footer
      @hidden="cancelRemove()"
    >
      <div class="button-list float-right">
        <b-button
          class="btn btn btn-icon"
          variant="primary"
          v-on:click="confirmRemove()"
          >Sim</b-button
        >
        <b-button
          class="btn btn btn-icon"
          variant="light"
          @click="showModalDelete = false"
          >Não</b-button
        >
      </div>
    </b-modal>
  </div>
</template>
